import React, { FC } from "react";
import { Description } from "@evergis/ui";
import { ProjectInfoDc, ResourceTypeLink, ServiceListItemDc, TableInfoDc } from "@evergis/api";

import { AdditionalProjectInfo } from "./AdditionalProjectInfo";
import { AdditionalLayerInfo } from "./AdditionalLayerInfo";
import { AdditionalTableInfo } from "./AdditionalTableInfo";
import { AdditionalBlock } from "../styled";

import { formatDate } from "../../../../../utils/date";
import { useResourceType } from "../../../../../hooks/useResourceType";

import { ResourceInfoDc } from "../../../types";

type CardAdditionalBlockProps = {
  resource: ResourceInfoDc;
  hideDate?: boolean;
};

export const CardAdditionalBlock: FC<CardAdditionalBlockProps> = ({ resource, hideDate }) => {
  const { changedDate, createdDate } = resource;
  const [resourceType] = useResourceType();

  return (
    <AdditionalBlock>
      {!hideDate && <Description>{formatDate(changedDate || createdDate || new Date(null))}</Description>}
      {resourceType === ResourceTypeLink.Project && <AdditionalProjectInfo project={resource as ProjectInfoDc} />}
      {resourceType === ResourceTypeLink.Layer && <AdditionalLayerInfo layer={resource as ServiceListItemDc} />}
      {resourceType === ResourceTypeLink.Table && <AdditionalTableInfo table={resource as TableInfoDc} />}
    </AdditionalBlock>
  );
};
